import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { BaseInputFilter } from "domain/models/base-input-filter";
import { User } from "domain/entities/user";
import { IUserRepository } from "domain/contracts/user.contract";

class UserRepository implements IUserRepository {
  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/user/${id}`);
    return response.data;
  }

  async create(input: User): Promise<Message<User>> {
    const response = await httpClient.post(`/user`, { data: input });
    return response.data;
  }

  async update(input: User): Promise<Message<boolean>> {
    const response = await httpClient.put(`/user/${input.id}`, {
      data: input,
    });
    return response.data;
  }

  async getAll(filter: BaseInputFilter): Promise<Message<User[]>> {
    const response = await httpClient.get(`/user`, { params: filter });
    return response.data;
  }

  async getById(id: string): Promise<Message<User>> {
    const response = await httpClient.get(`/user/${id}`);
    return response.data;
  }
}

export default new UserRepository();
